import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { NotFoundPage } from "./not-found-page";
import { ServerErrorPage } from "./server-error-page";
import { SERVER_ERROR_MAP } from "./server-error-page";

export function RouterErrorElement() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) return <NotFoundPage />;
    if (error.status in SERVER_ERROR_MAP) {
      return <ServerErrorPage status={error.status as 500 | 502 | 503} />;
    }
  }

  throw error;
}
